module.exports = __webpack_public_path__ + "static/img/ent-81.63b6f94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-81.jpg
// module id = hWFS
// module chunks = 51